import { render } from "./CreateSquarePage.vue?vue&type=template&id=c8b968ea"
import script from "./CreateSquarePage.vue?vue&type=script&lang=js"
export * from "./CreateSquarePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__